import axiosInstance from "../service/axiosInterceptor";


export async function getAllAttendance() {
  try {
    const response = await axiosInstance.get("/api/attendance/admin");
    return response.data; // Return the data from the API response
  } catch (error) {
    throw error;
  }
}

export async function getMonthlyRegister(month, year) {
  try {
    const queryParams = new URLSearchParams({
      month,
      year,
    });
    
    const response = await axiosInstance.get(`/api/attendance/monthly-register?${queryParams}`);
    return response.data; // Return the data from the API response
  } catch (error) {
    throw error;
  }
}

export async function getAttendanceStatus(billerId) {
  try {
    const response = await axiosInstance.get("/api/attendance/status", {
      params: { billerId }, // Pass billerId as query parameter
    });
    return response.data; // Return the data from the API response
  } catch (error) {
    throw error;
  }
}

export async function exportMonthlyRegister(month, year, role) {
  try {
    const queryParams = new URLSearchParams({
      month,
      year,
    });

    const response = await axiosInstance.get(`/api/attendance/monthly-register/export?${queryParams}`, {
      responseType: "blob", // Ensure the response is treated as a file
    });

    // Create a temporary link element to trigger the download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `Attendance_${month}_${year}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    throw error;
  }
}

export async function PunchIn(billerId) {
  try {
    const response = await axiosInstance.post("/api/attendance/punch-in", { billerId });
    return response.data; // Return the data from the API response
  } catch (error) {
    throw error;
  }
}

export async function PunchOut(billerId, description) {
  try {
    const response = await axiosInstance.post("/api/attendance/punch-out", { billerId, description });
    return response.data; // Return the data from the API response
  } catch (error) {
    throw error;
  }
}

export async function StartBreak(billerId, breakType) {
  try {
    const response = await axiosInstance.post("/api/attendance/break-start", { billerId, breakType });
    return response.data; // Return the data from the API response
  } catch (error) {
    throw error;
  }
}

export async function EndBreak(billerId) {
  try {
    const response = await axiosInstance.post("/api/attendance/break-end", { billerId });
    return response.data; // Return the data from the API response
  } catch (error) {
    throw error;
  }
}

// New functions for admin to manage attendance

export async function getAttendanceById(attendanceId) {
  try {
    const response = await axiosInstance.get(`/api/attendance/${attendanceId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function updateAttendance(attendanceData) {
  try {
    const response = await axiosInstance.put('/api/attendance/update', attendanceData);
    return response.data;
  } catch (error) {
    throw error;
  }
}

